import "@/styles/globals.css";
import "@/utils/leaflet-globals"; // setzt window.L vor jeder Lazy-Route (Leaflet-Plugins brauchen es global)
import React from "react";
import ReactDOM from "react-dom/client";
import { Toaster } from "react-hot-toast";
import App from "./App";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
    <Toaster />
  </React.StrictMode>
);
